// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1sv9W","title":"AfterImages45_title__3CsE5","images":"AfterImages45_images__3ONd1"};